export default __webpack_public_path__ + "static/media/me2.104bb30a.jpg";